"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSubmitManualMeterReadCXToLegacy = exports.mapSubmitManualMeterReadGasCXToKapi = exports.mapSubmitManualMeterReadElecCXToKapi = exports.isSubmitManualMeterReadElecCX = void 0;
var date_fns_1 = require("date-fns");
var __generated__1 = require("../../../../shared/api/kapi/v1/__generated__/");
function isSubmitManualMeterReadElecCX(data) {
    return 'registers' in data;
}
exports.isSubmitManualMeterReadElecCX = isSubmitManualMeterReadElecCX;
var mapSubmitManualMeterReadElecCXToKapi = function (data) { return ({
    sprn: data.sprn,
    meterSerialNumber: data.meterSerialNumber,
    dateTime: getISODate(data.dateTime),
    lifecycle: __generated__1.ReadingLifecycle.Inlife,
    type: __generated__1.ReadingType_NextV1.Actual,
    source: __generated__1.MeterReadSource.ManualReadCustomer,
    force: data.force,
    registers: data.registers.map(function (_a) {
        var value = _a.value, registerId = _a.registerId;
        return ({
            value: value,
            // Only legacy reads will be missing the registerId.
            registerId: registerId || '',
        });
    }),
}); };
exports.mapSubmitManualMeterReadElecCXToKapi = mapSubmitManualMeterReadElecCXToKapi;
var mapSubmitManualMeterReadGasCXToKapi = function (data) { return ({
    sprn: data.sprn,
    meterSerialNumber: data.meterSerialNumber,
    dateTime: getISODate(data.dateTime),
    lifecycle: __generated__1.ReadingLifecycle.Inlife,
    type: __generated__1.ReadingType_NextV1.Actual,
    source: __generated__1.MeterReadSource.ManualReadCustomer,
    force: data.force,
    value: data.value,
}); };
exports.mapSubmitManualMeterReadGasCXToKapi = mapSubmitManualMeterReadGasCXToKapi;
var mapSubmitManualMeterReadCXToLegacy = function (data) {
    if (isSubmitManualMeterReadElecCX(data)) {
        return {
            readingDateTime: getReadingTime(data.dateTime),
            mpxn: data.sprn,
            tiers: data.registers.map(function (reg) {
                return {
                    meterRegisterReading: parseInt(reg.value),
                    timeOfUseLabel: reg.timingCategory,
                };
            }),
        };
    }
    return {
        readingDateTime: getReadingTime(data.dateTime),
        mpxn: data.sprn,
        gasVolume: parseInt(data.value),
    };
};
exports.mapSubmitManualMeterReadCXToLegacy = mapSubmitManualMeterReadCXToLegacy;
var getISODate = function (date) {
    return date ? (0, date_fns_1.parseISO)(date).toISOString() : (0, date_fns_1.startOfToday)().toISOString();
};
var getReadingTime = function (date) {
    return date
        ? (0, date_fns_1.format)(date, "yyyy-MM-dd'T'HH:mm:ss")
        : (0, date_fns_1.format)((0, date_fns_1.startOfToday)(), "yyyy-MM-dd'T'HH:mm:ss");
};
